import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommanModule } from './component/comman-component/comman/comman.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
//import { CommanHeaderComponent } from './component/comman-component/comman-header/comman-header.component';
import { CommanFooterComponent } from './component/comman-component/comman-footer/comman-footer.component';
import { LoginComponent } from './home-page/login/login.component';
import { BidderRegistrationComponent } from './home-page/bidder-registration/bidder-registration.component';
import { PaymentResponseComponent } from './home-page/payment-response/payment-response.component';
// import { LiveBiddingViewComponent } from './component/comman-component/live-bidding-view/live-bidding-view.component';
// import { ChangePasswordComponent } from './component/comman-component/change-password/change-password.component';

@NgModule({
  declarations: [
    AppComponent,
    CommanFooterComponent,
    LoginComponent,
    BidderRegistrationComponent,
    PaymentResponseComponent,
    // LiveBiddingViewComponent,
    // ChangePasswordComponent,
   
   
    //OnlyNumbersDirective,NumDeciOnlyDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommanModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      timeOut: 5000,
      closeButton: true,
      maxOpened: 1,
    }) // ToastrModule added

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
